// Shared heading for the homepage sections below the product story, in the
// story's style: a small orange label between two short rules, a dark green
// title with one phrase (`highlight`) in orange, and an optional subtitle.
// Both oranges are darkened from the brand #F88225 so they keep readable
// contrast on white and on the pale green bands.
const SectionHeading = ({
  eyebrow,
  title,
  highlight,
  subtitle,
  id,
  className = "",
}) => {
  const index = highlight ? title.indexOf(highlight) : -1;

  return (
    <div className={`mx-auto mb-10 max-w-3xl text-center ${className}`}>
      {eyebrow && (
        <p className="mb-3 flex items-center justify-center gap-3 text-sm font-bold text-[#b84f0a]">
          <span className="h-px w-8 bg-primary/60" aria-hidden="true" />
          {eyebrow}
          <span className="h-px w-8 bg-primary/60" aria-hidden="true" />
        </p>
      )}
      <h2
        id={id}
        className="text-2xl font-black leading-relaxed text-[#102b23] md:text-3xl"
      >
        {index < 0 ? (
          title
        ) : (
          <>
            {title.slice(0, index)}
            <span className="text-[#dd6a12]">{highlight}</span>
            {title.slice(index + highlight.length)}
          </>
        )}
      </h2>
      {subtitle && (
        <p className="mt-3 leading-8 text-[#4a5a54]">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeading;
